export default "__VITE_ASSET__DMFH2JkP__"